import { useEffect, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/webpack";
import mammoth from "mammoth";
import { HfInference } from "@huggingface/inference";
import Swal from 'sweetalert2';
import LoadingSpinner from "../helpers/loadingspinner";
import stringSimilarity from "string-similarity";
import { readyException } from "jquery";

const skillsList = [ 
  "JavaScript", "TypeScript", "Python","No SQL", "Java", "C#", "C", "CPP", "C++", "Cascading style sheets", "NodeJS", "Node",
  "PHP", "Swift", "ReactJS", "React", "AngularJS", "ExpressJs", "NestJS", "ParcelJS", "Threejs", "Vuejs", "dotnet",
  "ADB", "ADF", "Backbonejs", "Nextjs", "Hapijs", "Redux", "JS","DevOps",
  "Ruby",  "Rust", "Dart", "Scala", "Perl", "Objective-C", "VB.NET", "MATLAB", 
  "Charles Proxy","Fiddler","StackTrace","Shell Scripting", "PowerShell","Bash/Shell", "Lua", "Groovy", "Haskell", "Fortran", "COBOL", 
  "Delphi", "F#", "Elixir", "Erlang", "Julia", "Lisp", "Prolog", "Bash", "Ada",      
  "HTML", "HTML5", "CSS", "CSS3", "SCSS", "SASS", "Less", "Tailwind CSS", "Bootstrap", 
  "Material UI", "React.js", "Xcode","Next.js", "Angular", "Vue.js", "Svelte", "jQuery", 
  "Alpine.js", "Stencil.js",  "Backbone.js", "Three.js", "WebAssembly",  
  "Zustand", "Recoil", "GraphQL", "Apollo Client", "Vite", "Webpack", "Parcel.js",
  "Node.js", "Express.js", "Nest.js","Software Requirements", "Django", "Flask", "FastAPI", 
  "ASP.NET Core", "Ruby on Rails", "Laravel", "Phoenix", "Koa.js", "Hapi.js", "Micronaut", 
  "Quarkus", "Strapi", "LoopBack", "AdonisJS", "Fiber", "Actix", "Rocket", 
  "Vert.x", "Grails", "ColdFusion", "Falcon", "Bottle", "Tornado",      
  "MySQL", "PostgreSQL", "MongoDB", "Firebase", "SQLite", "Redis", "DynamoDB", "SQL", 
  "Cassandra", "Oracle DB", "Microsoft SQL Server", "MariaDB", "Amazon RDS", "Aurora", 
  "CockroachDB", "Neo4j", "Logcat", "ArangoDB", "Couchbase", "Elasticsearch", "Solr", "InfluxDB", 
  "TimescaleDB", "HBase", "Bigtable", "RavenDB", "Firestore", "OrientDB", "Realm", 
  "FaunaDB", "ScyllaDB", "AWS","Amazon Web Services", "Amazon S3", "Amazon EC2", "Amazon Lambda", "Azure", "Azure Functions", 
  "Azure DevOps", "Google Cloud Platform (GCP)", "Firebase Hosting", "Cloudflare","VMware",
  "Heroku", "DigitalOcean", "Kubernetes", "Docker",  "Ansible", "Chef", "Cloud Computing",
  "Puppet", "Jenkins",  "GitLab CI/CD", "CircleCI", "ArgoCD", "Nomad", "Multilayer Networking",
  "Vagrant", "Helm", "Consul", "Istio", "Linkerd", "Vault", "Grafana", 
  "New Relic",  "Splunk", "Elastic Stack (ELK)", "Machine Learning", "Deep Learning",
  "Artificial Intelligence", "Natural Language Processing (NLP)", "Computer Vision", "TensorFlow", "Keras", "PyTorch", "Hugging Face Transformers", 
  "OpenCV", "Scikit-learn", "XGBoost", "LightGBM", "spaCy", "NLTK", "Gensim", "Service Mapping",
  "FastText", "Transformers", "BERT", "GPT", "LLaMA", "Stable Diffusion", "LangChain", 
  "MLflow", "Kubeflow", "Dask", "Ray", "Optuna", "ONNX", "TFLite", "ETL", "Apache Kafka", 
  "Apache Spark", "PySpark", "Hadoop", "Flink", "Hive", "HBase", "Pig", "Presto", "Trino", 
  "Airflow", "NiFi", "Kinesis", "Google BigQuery", "Amazon Redshift","Hive Optimization",
  "Delta Lake", "Data bricks","Apache Beam", "AWS Glue", "QA","Autosys Job Scheduling",
  "Azure Data Factory", "Azure Synapse Analytics", "ClickHouse", "Druid", "Predictive Analytics",     
  "Ethical Hacking", "Penetration Testing", "OWASP", "Burp Suite", "Metasploit", 
  "Wireshark", "Snort", "Nmap", "Kali Linux", "Suricata", "Zeek", "Fail2Ban", 
  "SSL/TLS", "Data Encryption", "Hashing", "JWT", "OAuth", "SAML", "IAM", "SIEM", "SOC", 
  "Firewalls", "Zero Trust", "ISO 27001", "SOC 2 Compliance", "GDPR", "HIPAA", 
  "PCI DSS", "MITRE ATT&CK", "React Native", "Flutter",  "Kotlin","Row/Column Access Control",
  "Java (Android)", "Objective-C (iOS)", "Generative AI","Large Language Models",
  "Ionic", "Cordova", "Xamarin", "NativeScript", "Jetpack Compose", "Unity", "Unreal Engine",
  "Solidity", "Ethereum", "Hyperledger Fabric", "Corda", "Polkadot", "Substrate", 
  "Cosmos SDK", "Web3.js", "Ethers.js", "Hardhat", "Truffle", "Ganache", "IPFS", 
  "The Graph", "Chainlink", "Polygon", "Solana", "Rust (Solana)", "Near Protocol", 
  "Avalanche", "Bitcoin Script", "Git", "GitHub", "GitLab", "Bitbucket", "JIRA", "Confluence", "Trello", 
  "Asana", "Slack", "Notion", "Linux", "Ubuntu", "CentOS", "Red Hat", "Windows Server", 
  "Bash Scripting","REST APIs", "GraphQL APIs", "gRPC", "WebSockets", 
  "WebRTC", "Microservices", "Serverless", "System Design", "Test-Driven Development (TDD)", 
  "Behavior-Driven Development (BDD)", "Mocha", "Chai", "Cypress", "Playwright", 
  "Selenium", "Appium", "Postman", "Swagger", "Figma", "Adobe Tools", "Sketch", "Cucumber","log4j","JUnit",
  // Added missed skills
  "IBM Cloud", "Oracle Cloud", "Alibaba Cloud",  "Mercurial", "OpenAI API", "ServiceNow ITOM",
  "FastAPI (ML)",  "Rancher", "Jenkins X", "Octopus","Data Product Ownership",
  "Neo4j (Graph)", "CouchDB", "AWS Lambda","API Development", "TOGAF","Mobile App Testing",
   "K3s",  "Tableau","Data Validation", "Data Visualization", "Tableau Prep", "Tableau Desktop", "Tableau Server", 
  "Tableau Public", "Tableau Online", "Tableau Mobile", "Dashboard Design", "Data Analytics","Big Data Analytics",
  "SQL for Tableau", "Data Blending in Tableau", "Tableau Calculations", "Tableau Reporting", "FinOps","Delta Lakehouse",
  "Tableau Data Integration", "Tableau Scripting", "Tableau Extracts", "Tableau Automation", "DataOps","Data Privacy","Data Security",
 "Business Intelligence", "Business Intelligence (BI)", "Data Warehousing","Spring Core","Spring Boot","Spring MVC",    "Spring Data",    "Spring Security",    "Spring AOP (Aspect-Oriented Programming)",
  "Spring Cloud", "Teradata",   "Spring Batch",    "Spring WebFlux",    "Spring Integration",    "Spring Web Services (Spring-WS)",
 "Spring Test",    "Spring JMS (Java Message Service)",    "Spring AMQP (Advanced Message Queuing Protocol)",
 "Spring OAuth2",    "Spring Kotlin","Data Lineage",    "Spring HATEOAS","Azure Kubernetes Service","Spark Pools",
 "Spring Transaction Management",    "Spring Boot Actuator","Spring Validation", "Spring REST",    "Spring Container",    "Spring DI (Dependency Injection)",    "Spring WebSocket",
 "Spring Microservices","IntelliJ IDEA", "Eclipse", "NetBeans", "Spring Tool Suite (STS)","JDeveloper",
 "BlueJ","JCreator", "Android Studio", "Visual Studio Code","MLOps","Cloud ETL/ELT","Medallion Architecture",
 "AI", "Machine Learning Operations (MLOps)", "Data Science", "AI Ethics", "Data Governance", "Dimensional Modeling","Meta Data Governance",
 "Data Lakes", "Data Mesh", "Data Fabric", "Data Engineering", "Business Intelligence (BI) Tools", "Unity Catalog","F5 Load Balancer","Multi-layer Networking",
 "Hadoop Ecosystem", "Apache Airflow", "Big Data", "Data Pipelines", "Data Wrangling", "Version Control ","Databricks Unity Catalog",
 "Data Preprocessing", "Data Visualization Tools", "RPA (Robotic Process Automation)", "Snowflake Cloud Data Warehouse",
 "Low-Code Platforms", "Blockchain Development", "Quantum Computing", "Edge Computing","Defect Tracking Systems", 
 "AI Model Deployment", "Graph Databases", "Knowledge Graphs", "Blockchain Smart Contracts", 
 "Web3 Development", "Solidity Programming", "Ethereum Blockchain", "NFTs", "Cryptocurrency", 
 "Automated Testing", "Unit Testing", "Integration Testing", "System Testing", "Regression Testing", 
 "Performance Testing", "Security Testing", "User Acceptance Testing (UAT)", "Test Automation", 
 "CI/CD Pipelines", "DevSecOps", "Cloud-Native Applications", "Hybrid Cloud", "Multicloud", 
 "Cloud Migration", "Edge Computing", "Serverless Architectures", "Container Orchestration", 
 "Service Mesh", "API Management", "API Gateway", "API Security", "OAuth2.0", "JWT Authentication", 
 "OAuth2.0 Flows",  "OpenID Connect", "SSO", "IAM (Identity and Access Management)", "Loki",
 "DevOps Automation", "Continuous Integration", "Continuous Deployment", "Infrastructure as Code (IaC)", 
 "Monitoring and Observability", "Log Management", "CloudWatch", "Prometheus Monitoring","AI Life Cycle Solutions", 
 "Grafana Dashboards", "Jenkins Pipelines",  "GitOps", "Terraform", "Pulumi", "CloudFormation", "AI Model Architecture",
 "Kubernetes Operators", "Kubernetes Ingress", "Kubernetes Networking", "Microservices Architecture", 
 "Service-Oriented Architecture (SOA)", "Event-Driven Architecture", "GraphQL Servers", "REST API Design", 
 "gRPC Services", "Protocol Buffers", "Event Sourcing", "CQRS (Command Query Responsibility Segregation)", 
 "Kafka Streams", "Reactive Programming", "RxJS", "Sagas", "Redux-Saga", "Redux Thunk", "State Management", 
 "Flux Architecture", "Observer Pattern", "Functional Programming", "Object-Oriented Programming (OOP)", 
 "Design Patterns", "SOLID Principles", "Clean Architecture", "TDD (Test-Driven Development)", 
 "BDD (Behavior-Driven Development)", "CI/CD Tools", "Selenium WebDriver", "Cypress", "Playwright", 
 , "Mocha", "Chai",  "Karma", "Jasmine", "Mockito", "Jenkins Automation", "Docker Swarm","Data Cataloging", 
 "OpenShift", "Cloud Foundry", "Elastic Beanstalk", "DigitalOcean Kubernetes", "HashiCorp Vault", 
 "API Gateway", "Postman API Testing", "Swagger/OpenAPI", "Redash", "Power BI", "Looker", "Google Data Studio",
 "ETL Processes","ETL","Alteryx","Adeptia ETL","Snowflake","Data Extraction","Data Curation","Data Integrity","Data Quality", "Data Pipelines", "AWS Glue", "Talend", "Informatica", "SSIS", "Fivetran", 
 "Apache Kafka Streams","Erwin Data Modeling", "Flume", "Apache NiFi", "Apache Camel", "Kubernetes Service Mesh", 
 "Istio Service Mesh", "Linkerd", "Vault by HashiCorp", "ElasticSearch", "Logstash", "Kibana (ELK Stack)", 
 "Prometheus", "Grafana", "Datadog",  "Zabbix", "Nagios", "Nagios XI", "OpenTelemetry", 
 "Dynatrace", "ServiceNow","ServiceNow HAM", "RPA Tools", "UiPath", "Automation Anywhere", "Blue Prism", "TestComplete", "Jaeger/OpenTracing",
 "Appium", "Selenium","Denodo","Talend", "XCUITest", "Flutter Testing", "Mobile Testing", "Agile Methodologies", "OLAP & OLTP Models",
 "Scrum Framework", "Kanban", "Lean Methodology", "DevOps Culture", "Agile Coach", "Scrum Master", "Agile & Scrum Methodology",
 "Product Owner", "Project Management", "Jira", "Confluence", "Asana", "Trello", "Slack", "Notion", "Miro", 
 "Figma", "Sketch", "Adobe XD", "Zeplin", "Design Systems", "Wireframing", "Prototyping", "Data Platforms & Services",
 "UI/UX Design", "Material Design", "iOS Development", "Android Development", "Flutter", "React Native","ER Studio", 
 "Xamarin", "Ionic", "NativeScript", "SwiftUI", "Jetpack Compose", "Android SDK", "iOS SDK", "UI Automation", 
 "Git", "GitHub", "GitLab", "Bitbucket", "SVN", "Mercurial", "Bitbucket Pipelines", "ADF Pipelines",
 "GitHub Actions", "Docker Compose", "Cloud Build", "Vagrant", "Nginx", "AI/ML Platform Deployment","Apache HTTP Server", 
 "Load Balancing", "DNS", "HTTP/2", "WebSockets", "WebRTC", "WebSockets Programming", "TCP/IP", 
 "VPN Technologies", "Firewalls", "Intrusion Detection Systems (IDS)", "Intrusion Prevention Systems (IPS)", 
 "Network Security", "Security Operations Center (SOC)", "Penetration Testing", "Threat Hunting", 
 "Incident Response","Incident Management","Problem Management","Vulnerability Management", "DLP (Data Loss Prevention)", "WAF (Web Application Firewall)", 
 "IAM Policies", "Cloud Security", "Zero Trust Security", "Encryption Algorithms", "SSL/TLS", "PKI (Public Key Infrastructure)", 
 "Risk Management", "HIPAA", "GDPR", "SOC 2", "ISO 27001", "PCI DSS", "CMMC", "Threat Intelligence", 
 "Malware Analysis", "Endpoint Detection & Response (EDR)", "Azure Sentinel", "Splunk Enterprise Security", 
 "SAST (Static Application Security Testing)", "DAST (Dynamic Application Security Testing)", 
 "XDR (Extended Detection and Response)", "RASP (Runtime Application Self-Protection)", "SIEM Tools", 
 "Cloud-Native Security", "Cloud Security Posture Management (CSPM)", "Vulnerability Scanning", 
 "Cyber Threat Intelligence", "Security Automation", "CrowdStrike", "Palo Alto Networks", "Check Point", 
 "Fortinet", "FireEye", "McAfee", "Trend Micro", "Symantec", "Cisco Security", "Tanium", "SonicWall", 
 "Rapid7", "Zscaler", "SentinelOne", "ThreatConnect", "Okta", "Ping Identity", "AWS Shield", 
 "Azure Security Center", "Google Cloud Security", "Cloud Identity", "SOC 2 Compliance", "Cloud Security Audits", 
 "Security Monitoring", "Penetration Testing Tools", "Wireshark", "Nmap", "Kali Linux", "Metasploit", "Burp Suite",
 "Serverless Framework",  "GraphQL Subscriptions","WebAssembly (WASM)","ReactiveX (RxJS)", "Server-Side Rendering (SSR)",
 "Prisma", "Jest","MongoDB Atlas","AWS CDK","Vercel","Cloudflare Workers", "OAuth 2.0",
 "JWT (JSON Web Tokens)","PostgreSQL","Firebase Firestore", "Tailwind UI","Bash Scripting","Ansible",
 "Vagrant","GraphQL Apollo Server","Sentry","Strapi","UI/UX","OOPS","OOPS concepts","Data Modeling","Collabera"
 ,"Spark Development","Databricks Delta Live Tables (DLT)","Lambda-based Triggers","API Integration in Databricks",
"Databricks Workflows","Data Profiling","Data Mapping","Data Reconciliation","Azure EventHub",
,"ADLS Gen2","Azure Key Vault","Data Migration","AWS S3","AWS EMR","AWS Athena","AWS Redshift",
,"Defect Tracking","Change Management","Service Level Agreements","SLAs","Notebooks","Data Aggregation","Data Transformation",
"Metadata Management","Data Orchestration","Salesforce","Cloudera","Unix Commands","Master Data Management","Stream Analytics",
"Cosmos DB","NumPy","Pandas","Matplotlib","Site Reliability Engineering","Platform Engineering",
"Solutions Architecture","pSQL","RDBMS"];
console.log(skillsList.length)

const ResumeAnalyzer = () => {
  const [resumes, setResumes] = useState([]); // Store multiple resumes
  const [loading, setLoading] = useState(false);
  const [comparisonResults, setComparisonResults] = useState([]);
  const [jobResponsibilities, setJobResponsibilities] = useState("");
   const [previousJobResponsibilities, setPreviousJobResponsibilities] = useState("");  
    const [previousResult, setPreviousResult] = useState(null);

    const [resumeText, setResumeText] = useState("");
    const [error, setError] = useState(null);
    const [matchPercentage, setMatchPercentage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
   const [extractedCertifications, setExtractedCertifications] = useState([]);
    const [showDetails, setShowDetails] = useState(false);
   
   
   
useEffect(()=>{
    if(resumeText  && jobResponsibilities) {
      setShowDetails(false);
    }
  },[])
    
  const extractDetails = async (resumeText, fileName) => {
    console.log("166",resumeText)
    try {
      const API_KEY = process.env.REACT_APP_HF_API_KEY;
      const hf = new HfInference(API_KEY);

      const normalizedText = resumeText.replace(/[,]/g, "").replace(/\s+/g, " ").trim().toLowerCase();

      const emailMatch = resumeText.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g);
      const email = emailMatch ? emailMatch[0] : "Not Found";

      const phoneMatch = normalizedText.match(/\b(?:\+?\d{1,3}[ -]?)?\d{10}\b/g);
      const phone = phoneMatch ? phoneMatch[0] : "Not Found";

      let name = "Not Found";

      try {
        const nerResponse = await hf.tokenClassification({
          model: "dslim/bert-base-NER",
          inputs: resumeText,
        });

        let nameEntities = [];
        let prevEnd = -1;

        nerResponse.forEach((entity) => {
          if (entity.entity_group === "PER") {
            let cleanWord = entity.word.replace(/^##/, ""); // Remove subword artifacts

            // Merge consecutive name parts
            if (entity.start === prevEnd) {
              nameEntities[nameEntities.length - 1] += " " + cleanWord;
            } else {
              nameEntities.push(cleanWord);
            }

            prevEnd = entity.end;
          }
        });
        if (nameEntities.length) {
          name = nameEntities.join(" ");
        }
      } catch (err) {
        console.error("Hugging Face API Error:", err);
      }

      if (name === "Not Found") {
        const nameMatch = resumeText.match(/\n([A-Z][a-zA-Z]+(?:\s[A-Z][a-zA-Z]+)*)\n\s*\S+@\S+/);
        if (nameMatch) {
          name = nameMatch[1].trim();
        }
      }

const normalizeSkill = (skill) => skill.toLowerCase().replace(/\s+/g, "");
const resumeWords = resumeText.toLowerCase().split(/\s+/);

const foundSkills = skillsList.filter((skill) => {
  const normalizedSkill = normalizeSkill(skill);
  const matches = stringSimilarity.findBestMatch(normalizedSkill, resumeWords);
  return matches.bestMatch.rating >= 0.75; // 90% similarity threshold
});

   // ✅ Extract Certifications for this resume
   const apiKey = process.env.REACT_APP_API_GENERATIVE_LANGUAGE_CLIENT;
   const response = await fetch(
    `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`,
    {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({
         contents: [
           {
             parts: [
               {
                 text: `Extract all certifications mentioned in this resume text. 
                   Return only a comma-separated list of certifications without extra text:\n\n${resumeText}`,
               },
             ],
           },
         ],
       }),
     }
   );

   const data = await response.json();
   console.log(`API Response for ${fileName}:`, data);

   let certifications = [];
   if (data.candidates && data.candidates.length > 0) {
     const responseContent = data.candidates[0]?.content?.parts?.[0]?.text || "";
     certifications = responseContent?.split(",")?.map((cert) => cert.trim());
   }

   if (certifications.length === 0) {
     certifications = ["Not Found"];
   }
   setResumes((prev) => [
     ...prev,
     { 
       fileName, 
       name, 
       email, 
       phone, 
       skills: foundSkills.length ? foundSkills : ["Not Found"], 
       certifications  // <-- Adding certifications here
     },
   ]);
       
      } catch (error) {
        console.error("Error extracting details:", error);
      }
    };
     
    const handleFileUpload = async (event) => {
      const files = Array.from(event.target.files);
      if (!files.length) return;
      setPreviousResult(null);
      setShowDetails(false);
      setLoading(true);

      const allowedFormats = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]; // PDF & DOCX
      
      const invalidFiles = files.filter(file => !allowedFormats.includes(file.type));
      if (invalidFiles.length > 0) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please upload only .pdf or .docx files',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
    
      setResumes([]); // Clear previous resume data
      const resumeTexts = []; // Store extracted text from multiple resumes
    
      try {
        const extractedResumes = [];
        await Promise.all(
          
          files.map(async (file) => {
            const reader = new FileReader();
    
            const processText = async (text) => {
              resumeTexts.push({ fileName: file.name, text }); // Store text with filename
              const details =    await extractDetails(text, file.name); // Process details
              extractedResumes.push(details)
            };
    
            return new Promise((resolve, reject) => {
              reader.onload = async () => {
                try {
                  if (file.name.endsWith(".pdf")) {
                    const arrayBuffer = reader.result;
                    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                    let extractedText = "";
    
                    for (let i = 1; i <= pdf.numPages; i++) {
                      const page = await pdf.getPage(i);
                      const textContent = await page.getTextContent();
                      extractedText += textContent.items.map((item) => item.str).join(" ") + " ";
                    }
    
                    await processText(extractedText);
                  } else if (file.name.endsWith(".docx")) {
                    const result = await mammoth.extractRawText({ arrayBuffer: reader.result });
                    await processText(result.value);
                  }
                  resolve();
                } catch (error) {
                  console.error(`Error processing ${file.name}:`, error);
                  reject(error);
                }
              };
    
              reader.onerror = reject;
    
              if (file.name.endsWith(".pdf") || file.name.endsWith(".docx")) {
                reader.readAsArrayBuffer(file);
              } else {
                reject(new Error("Invalid file type"));
              }
            });
          })
        );
        setResumeText(resumeTexts); // Save extracted texts array
        setLoading(false);
      } catch (error) {
        console.error("Error extracting resume details:", error);
      }
    };
    

    const analyzeResume = async () => {
      
      if (!resumeText || resumeText.length === 0 || !jobResponsibilities) {
        alert("Please upload at least one resume and enter job responsibilities.");
        return;
      }
    
      // 🛑 If job responsibilities haven't changed, use the last result
      if (jobResponsibilities === previousJobResponsibilities && previousResult !== null) {
        console.log("Using cached result:", previousResult);
        setMatchPercentage(previousResult);
  
        return;
      }
    
      try {
        const apiKey = process.env.REACT_APP_API_GENERATIVE_LANGUAGE_CLIENT;
        const requests = resumeText.map(async (resume, index) => {
          // await new Promise(resolve => setTimeout(resolve, 2000));  // 2 sec delay
          const response = await fetch(
            `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                contents: [
                  {
    parts: [
      {
        text: `Step 1: Extract the roles and responsibilities from the following **resume content**.  
        Step 2: Compare the extracted roles and responsibilities with the provided **job responsibilities**.  
        Step 3: Determine the relevance and calculate a match percentage based on how closely they align.  
        
        ### **Instructions:**  
        - Read the **resume content** and extract the key **roles and responsibilities** in a structured manner.  
        - Compare the extracted responsibilities with the **job responsibilities** given below.  

        - Identify **mandatory skills, certifications, or tools** mentioned in the job description and compare them with those found in the resume.  
        - Clearly state which **mandatory skills, certifications, or tools** are **present** in the resume and which are **missing**.  


        - Provide a match percentage based on how similar they are.  
        - **Only return a number followed by % (e.g., 85%)**, without any extra text.  
        - **Also explain why this percentage was given in 10-15 lines.**  
        
        #### **Resume Content:**  
        ${resume.resumeText} 
        
        #### **Job Responsibilities:**  
        ${jobResponsibilities}
        
        ### **Response Format:**  
        **Match Percentage:** XX%  
        **Reason:** (explanation of the match percentage)`
      }
    ]
                  }
                ]
              })
            }
          );
    
          const data = await response.json();
          console.log(`API Response for Resume ${index + 1}:`, data);
    
          if (!data.candidates || data.candidates.length === 0) {
            throw new Error(`No candidates found for Resume ${index + 1}.`);
          }
    
          const responseContent = data.candidates[0]?.content?.parts?.[0]?.text || "";
          console.log(`Extracted Response Content for Resume ${index + 1}:`, responseContent);
    
          // Extract match percentage
          const match = responseContent.match(/\d+%/);
          const result = match ? match[0] : "N/A";
    
          // Extract the reason (anything after "Reason:")
          const reasonMatch = responseContent.match(/Reason:\s*([\s\S]*)/);
          const reasonText = reasonMatch ? reasonMatch[1].trim() : "No reason provided.";
    
          // Clean and format reason text
          let cleanedReasonText = reasonText.replace(/\*\*/g, "").trim();
          const reasonList =await cleanedReasonText
            .split(/\n|\. /)
            .map(item => item.trim())
            .filter(item => item && item !== "**");
    
          if (reasonList.length > 0 && reasonList[0].startsWith("**")) {
            reasonList[0] = reasonList[0].replace(/^\*\*/, "").trim();
          }
    
          return { resumeIndex: index + 1, matchPercentage: result, reasons: reasonList };
        });
    
        // Execute all API requests concurrently
        const results = await Promise.all(requests);
      //  setMatchReason(results);
        setPreviousJobResponsibilities(jobResponsibilities);
        setPreviousResult(results);
        setMatchPercentage(results);
       setResumes((prev) => [
          ...prev.map((resume, index) => ({
            ...resume,
            matchPercentage: results[index]?.matchPercentage || "N/A",
            reasons: results[index]?.reasons || ["No reason provided."]
          }))
        ]);
        return results;
              } catch (err) {
        console.error("Error calling AI API:", err);
      }
    };        
  const analyzeCertifications = async () => {    
      if (!jobResponsibilities || !resumeText || resumeText.length === 0) {
        setError("Please upload a resume and enter job responsibilities.");
        return;
      }
    
      try {
        const apiKey = process.env.REACT_APP_API_GENERATIVE_LANGUAGE_CLIENT;
        let allMatchedCertifications = [];
    
        for (let i = 0; i < resumeText.length; i++) {
          const currentResume = resumeText[i]; // Process each resume separately
          // await new Promise(resolve => setTimeout(resolve, 2000));  // 2 sec delay
          const response = await fetch(
            `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                contents: [
                  {
                    parts: [
                      {
                        text: `### **Task:**  
                  1️⃣ Extract only explicit certifications from the resume content.
                  2️⃣ Extract only explicit required certifications from the job responsibilities.
                  3️⃣ Compare both lists and return only exact matches (no semantic similarity checks).
                  
                  🔍 Important:
                  
                  Do not infer or assume certifications based on general skills.
                  If no exact certification names match, return: No matched certifications found.
                  #### **Resume Content:**  
                  ${currentResume.resumeText}  
                  
                  #### **Job Responsibilities:**  
                  ${jobResponsibilities}  
                  
                  ### **Response Format:**  
                  **Matched Certifications:**  
                  - Certification 1  
                  - Certification 2`
                      }
                    ]
                  }
                ]
              }),
            }
          );
    
          const data = await response.json();
          console.log(`API Response for Candidate ${i + 1}:`, data);
    
          if (!data.candidates || data.candidates.length === 0) {
            throw new Error(`No candidates found in response for candidate ${i + 1}.`);
          }
    
          const responseContent = data.candidates[0]?.content?.parts?.[0]?.text || "";
          console.log(`Extracted Response Content for Candidate ${i + 1}:`, responseContent);
    
          // Extract Matched Certifications
          const matchedCertificationsMatch = responseContent.match(/(?<=\*\*Matched Certifications:\*\*\n)([\s\S]*?)(?=\n\n|$)/);
      const matchedCertifications = matchedCertificationsMatch 
        ? matchedCertificationsMatch[1]
            .split("\n")
            .filter((line) => line.startsWith("- ")) 
            .map((cert) => cert.replace("- ", "").trim()) 
        : [];

      // Ensure that if no certifications match, we set a default message
      const finalCertifications = matchedCertifications.length > 0 
        ? matchedCertifications 
        : ["No matched certifications found"];

      // Store candidate-specific matched certifications
      allMatchedCertifications.push({
        resumeIndex: i + 1,
        matchedCertifications: finalCertifications,
      });
    }
    
        setExtractedCertifications(allMatchedCertifications); // Store results for all candidates
        setResumes((prev) => prev.map((resume, index) => ({
          ...resume,
          matchedCertificationswithJobResponsibilities: allMatchedCertifications[index]?.matchedCertifications || [],
        })));
        return allMatchedCertifications;
      } catch (err) {
        console.error("Error calling AI API:", err);
      }
    };

  const extractSkillsFromText = (text) => {
  const normalizeSkill = (skill) => skill.toLowerCase().replace(/\s+/g, ""); // Normalize skill
  const resumeWords = text.toLowerCase().split(/\s+/); // Normalize and split resume text

  return skillsList.filter((skill) => {
    const normalizedSkill = normalizeSkill(skill);
    const matches = stringSimilarity.findBestMatch(normalizedSkill, resumeWords);
    return matches.bestMatch.rating >= 0.85; // 90% similarity threshold
  });
    };

    const compareSkills = async () => {
      setShowDetails(false);
      setIsLoading(true);

      let resumeAnalysisResults;
      if (jobResponsibilities == previousJobResponsibilities && previousResult != null) {
          console.log("Using cached result:", previousResult);
          resumeAnalysisResults = previousResult;
      } else {
          resumeAnalysisResults = await analyzeResume();
      }
      const macthedCertificationAnalysisResults = await analyzeCertifications();
      console.log("580",macthedCertificationAnalysisResults)
    
      if (resumes.length === 0) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please upload at least one .pdf or .docx resume',
          showConfirmButton: false,
          timer: 3000
        });
        setIsLoading(false);
        return;
      }
      if (!jobResponsibilities.trim()) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please enter at least one job skill',
          showConfirmButton: false,
          timer: 3000
        });
        setIsLoading(false);
        return;
      }
    
      const extractedJobSkills = extractSkillsFromText(jobResponsibilities);
    
      const results = resumes.map((resume, index) => {
        const matchedSkills = resume.skills.filter((skill) =>
          extractedJobSkills.map((s) => s.toLowerCase()).includes(skill.toLowerCase())
        );
    
        const matchPercentage =
          extractedJobSkills.length > 0
            ? Math.round((matchedSkills.length / extractedJobSkills.length) * 100)
            : 0;
    
        const matchResult =
          matchedSkills.length > 0
            ? `Matched Skills: ${matchedSkills.join(", ")}`
            : "❌ No Matched Skills.";
    
        const matchedPercentage =
          matchedSkills.length > 0
            ? `Matched Skill Percentage: ${matchPercentage}%`
            : "❌ No Matched Skills Percentage.";
    
        // Retrieve the analysis result from analyzeResume()'s return value
        const resumeAnalysis = resumeAnalysisResults?.find(r => r.resumeIndex === index + 1);
        const analyzedMatchPercentage = resumeAnalysis?.matchPercentage || "N/A";
        const analyzedReasons = resumeAnalysis?.reasons || ["No reason provided."];
        const analyzedMatchedCertifications = macthedCertificationAnalysisResults?.find(r => r.resumeIndex === index + 1);
        const analyzedCertifications = analyzedMatchedCertifications?.matchedCertifications || ["No matched certification."];

        return {
          ...resume,
          matchResult,
          matchedPercentage,
          analyzedMatchPercentage,
          analyzedReasons,
          analyzedCertifications
        };
      });
      console.log("results",results)
      setComparisonResults(results);
      setShowDetails(true);
      setIsLoading(false);
    };
    

  return (
        <>    
  <div style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
  <h5 style={{color:"#00a7ac"}}>Upload Resume</h5>
            <input  className="form-control basic-form"
 type="file" accept=".pdf, .docx" multiple onChange={handleFileUpload} style={{ marginBottom: "10px" }} />
            {loading ? <p>Processing Resumes... Please wait.</p> :
           <div style={{ width: "100%", gap: "20px", marginTop: "10px" }}>
           <h5 style={{color:"#00a7ac"}}>Enter Job Responsibilities and Key Skills</h5>
         
        <textarea
        placeholder="Enter job responsibilities and key skills here..."
        value={jobResponsibilities}
        className="form-control basic-form"
        onChange={(e) => setJobResponsibilities(e.target.value)}
        style={{ width: "100%", height: "200px", padding: "10px" }}
      />

            </div>
}
          </div>
          <button   onClick={() => {compareSkills(); }}  className="btn btn-primary mt-3"> Compare</button>
          <div style={{ marginTop: "20px" }}>
          <h4 style={{color:"#00a7ac"}}>Comparison Results</h4>
          
      {  isLoading ? <center><LoadingSpinner /></center> :   
                           comparisonResults.length > 0 &&  showDetails  ? (
            comparisonResults.map((resume, index) => (
              <div
                key={index}
                style={{
                  background: "#f4f4f4",
                  padding: "10px",
                  borderRadius: "5px",
                  marginBottom: "10px",
                }}
              >
                <p style={{fontSize:18}}><strong>File:</strong> {resume.fileName}</p>
                <p style={{fontSize:18}}><strong>Email:</strong> {resume.email}</p>
                <p style={{fontSize:18}}><strong>Phone Number:</strong> {resume.phone}</p>
              
            <p style={{fontSize:18}}><strong>Resume Skills:</strong> {resume.skills.join(", ")}</p>
                {jobResponsibilities.trim() !== "" && (
        <p style={{ fontSize: 18 }}> <strong>JD Skills:</strong> {extractSkillsFromText(jobResponsibilities).join(", ")}</p>
      )}
        <p style={{fontSize:18, fontWeight: "bold", color: resume.matchResult.includes("Matched") ? "#00a7ac" : "red" }}> {resume.matchResult}</p>
                <p style={{fontSize:18, fontWeight: "bold", color: resume.matchedPercentage.includes("Match") ? "#00a7ac" : "red" }}>
                <i className="fas fa-chart-line" style={{ marginRight: 10 }}></i>{resume.matchedPercentage}
                </p>
                <p style={{fontSize:18}}> <strong>Candidates Certifications:</strong> {resume.certifications.join(", ")}</p>
                <p style={{fontSize:18}}> <strong>Matched Certifications with Job Responsibilities: </strong>{resume.analyzedCertifications?.join(", ") || "No Matched Certifications Found"}</p>
                <p style={{fontSize:18,color:"#00a7ac"}}><i className="fas fa-chart-line" style={{ marginRight: 10 }}></i><strong>Matched Key Responsibilities Percentage: {resume.analyzedMatchPercentage || "N/A"}</strong> </p>
        <p style={{fontSize:18}}><strong>Matched Key Responsibilities Reason:</strong>
    <ul >
      {resume.analyzedReasons && resume.analyzedReasons.length > 0 ? (
        resume.analyzedReasons.map((reason, i) => <li key={i} style={{fontSize:18}}>{reason}</li>)
      ) : (
        <li>No reason provided.</li>
      )}
    </ul>
    </p>
      </div>
            ))
          ) : (
            <p>No comparison done yet.</p>
          )
        }
        </div>
         </>
  );
};

export default ResumeAnalyzer;